(function () {
  console.log('Init Venn cart handler');
  if (window.__vennCartBridgeLoaded) return;
  window.__vennCartBridgeLoaded = true;

  var DEBUG = true; // set to false in production if you want less logging
  var DEDUPE_MS = 1200;
  var lastEventFingerprint = null;
  var lastEventAt = 0;

  var PERSISTED_EVENTS_KEY = '__vennCartEvents';
  var PERSISTED_LOGS_KEY = '__vennCartLogs';
  var PENDING_FORM_RECONCILE_KEY = '__vennPendingFormReconcile';
  var LAST_CART_SNAPSHOT_KEY = '__vennLastCartSnapshot';
    
  var zeptoReconcileQueue = {};
  var ZEPTO_RECONCILE_DEBOUNCE_MS = 1000;

  var originalFetchFn = window.fetch ? window.fetch.bind(window) : null;

  function log() {
    if (!DEBUG) return;
    console.log.apply(console, ['[Venn bridge]'].concat([].slice.call(arguments)));
  }

  function persistPayload(payload, meta) {
    try {
      var existing = [];

      try {
        existing = JSON.parse(sessionStorage.getItem(PERSISTED_EVENTS_KEY)) || [];
      } catch (e) {}

      existing.push({
        payload: payload,
        meta: meta,
        timestamp: Date.now(),
        url: window.location.href
      });

      if (existing.length > 20) {
        existing = existing.slice(existing.length - 20);
      }

      sessionStorage.setItem(PERSISTED_EVENTS_KEY, JSON.stringify(existing));
    } catch (err) {
      console.warn('[Venn bridge] Failed to persist payload', err);
    }
  }

  function persistLog(label, data) {
    try {
      var existing = [];

      try {
        existing = JSON.parse(sessionStorage.getItem(PERSISTED_LOGS_KEY)) || [];
      } catch (e) {}

      existing.push({
        label: label,
        data: data,
        timestamp: Date.now(),
        url: window.location.href
      });

      if (existing.length > 100) {
        existing = existing.slice(existing.length - 100);
      }

      sessionStorage.setItem(PERSISTED_LOGS_KEY, JSON.stringify(existing));
    } catch (err) {
      console.warn('[Venn bridge] Failed to persist log', err);
    }
  }
    
    function getMatchingCartLinesByPricingRefs(cart, pricingRefs) {
      var items = (cart && cart.items) || [];

      return items.filter(function (line) {
        return lineMatchesPricingRefs(line, pricingRefs);
      });
    }

    function countExpectedPayloadsForPricingRefs(payloads, pricingRefs) {
      if (!Array.isArray(payloads) || !pricingRefs || !pricingRefs.length) return 0;

      return payloads.filter(function (payload) {
        var ref = getPayloadProperty(payload, '_pc_pricing_ref');
        return !!(ref && pricingRefs.indexOf(String(ref)) !== -1);
      }).length;
    }

    function waitForCartLinesByPricingRefs(pricingRefs, expectedCount, options) {
      options = options || {};

      var timeoutMs = options.timeoutMs != null ? options.timeoutMs : 5000;
      var intervalMs = options.intervalMs != null ? options.intervalMs : 300;
      var startedAt = Date.now();

      function check() {
        return getCartJson().then(function (cart) {
          var matchingLines = getMatchingCartLinesByPricingRefs(cart, pricingRefs);

          persistLog('Zepto cart poll', {
            pricingRefs: pricingRefs,
            expectedCount: expectedCount,
            actualCount: matchingLines.length,
            matchingLines: matchingLines
          });

          if (matchingLines.length >= expectedCount) {
            return cart;
          }

          if (Date.now() - startedAt >= timeoutMs) {
            return cart;
          }

          return delay(intervalMs).then(check);
        });
      }

      return check();
    }

  function getSessionJson(key) {
    try {
      var raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (err) {
      return null;
    }
  }

  function setSessionJson(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (err) {}
  }

  function removeSessionKey(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (err) {}
  }

  function printPersistedDebug() {
    console.log('Getting persisted data payload');
    try {
      var storedEvents = getSessionJson(PERSISTED_EVENTS_KEY);
      if (storedEvents) {
        console.group('[Venn bridge] Persisted events');
        storedEvents.forEach(function (event, index) {
          console.log('#' + index, event);
        });
        console.groupEnd();
      }
    } catch (err) {
      console.warn('[Venn bridge] Failed to read persisted events', err);
    }

    console.log('Getting persisted logs');
    try {
      var storedLogs = getSessionJson(PERSISTED_LOGS_KEY);
      if (storedLogs) {
        console.group('[Venn bridge] Persisted logs');
        storedLogs.forEach(function (event, index) {
          console.log('#' + index, event);
        });
        console.groupEnd();
      }
    } catch (err) {
      console.warn('[Venn bridge] Failed to read persisted logs', err);
    }
  }
    
  function getEarliestCartSnapshot(a, b) {
      if (!a) return b || { items: [] };
      if (!b) return a || { items: [] };
      return a;
    }

    function queueZeptoBundleReconcile(payloads, meta, options) {
      options = options || {};

      var pricingRefs = collectPricingRefsFromPayloads(payloads);
      if (!pricingRefs.length) {
        return Promise.resolve();
      }

      var queueKey = pricingRefs.slice().sort().join('|');
      var existing = zeptoReconcileQueue[queueKey];

      if (!existing) {
        existing = zeptoReconcileQueue[queueKey] = {
          pricingRefs: pricingRefs.slice(),
          payloads: [],
          meta: meta,
          beforeCart: options.beforeCart || { items: [] },
          timer: null
        };
      }

      existing.payloads = existing.payloads.concat(payloads || []);
      existing.meta = meta || existing.meta;
      existing.beforeCart = getEarliestCartSnapshot(existing.beforeCart, options.beforeCart || { items: [] });

      if (existing.timer) {
        clearTimeout(existing.timer);
      }

      persistLog('Queued Zepto bundle reconcile', {
        queueKey: queueKey,
        pricingRefs: existing.pricingRefs,
        payloadCount: existing.payloads.length,
        meta: existing.meta
      });

      existing.timer = setTimeout(function () {
        var queued = zeptoReconcileQueue[queueKey];
        if (!queued) return;

        delete zeptoReconcileQueue[queueKey];

        reconcileZeptoPayloads(queued.payloads, queued.meta, {
          beforeCart: queued.beforeCart,
          settleDelayMs: 0
        });
      }, ZEPTO_RECONCILE_DEBOUNCE_MS);

      return Promise.resolve();
    }

  function isCartAddUrl(url) {
    if (!url) return false;

    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.pathname === '/cart/add' || parsed.pathname === '/cart/add.js';
    } catch (e) {
      return false;
    }
  }

  function toProductGid(id) {
    if (!id) return null;
    if (String(id).indexOf('gid://shopify/Product/') === 0) return String(id);
    return 'gid://shopify/Product/' + id;
  }

  function toVariantGid(id) {
    if (!id) return null;
    if (String(id).indexOf('gid://shopify/ProductVariant/') === 0) return String(id);
    return 'gid://shopify/ProductVariant/' + id;
  }

  function toSellingPlanGid(id) {
    if (!id) return null;
    if (String(id).indexOf('gid://shopify/SellingPlan/') === 0) return String(id);
    return 'gid://shopify/SellingPlan/' + id;
  }

  function safeParseInt(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  function clonePlainObject(value) {
    if (!value || typeof value !== 'object') return {};
    try {
      return JSON.parse(JSON.stringify(value));
    } catch (e) {
      var out = {};
      Object.keys(value).forEach(function (key) {
        out[key] = value[key];
      });
      return out;
    }
  }

  function normalizePropertyValue(value) {
    if (typeof File !== 'undefined' && value instanceof File) {
      return {
        name: value.name || '',
        type: value.type || '',
        size: value.size || 0
      };
    }
    return value;
  }

  function extractLineItemProperties(formData) {
    var attributes = {};

    for (var pair of formData.entries()) {
      var key = pair[0];
      var value = normalizePropertyValue(pair[1]);

      var match = key.match(/^properties\[(.*)\]$/);
      if (!match) continue;
      if (value === '' || value == null) continue;

      var name = match[1];

      if (attributes[name] !== undefined) {
        if (!Array.isArray(attributes[name])) {
          attributes[name] = [attributes[name]];
        }
        attributes[name].push(value);
      } else {
        attributes[name] = value;
      }
    }

    return attributes;
  }

  function formDataToPlainObject(formData) {
    var obj = {};
    for (var pair of formData.entries()) {
      var key = pair[0];
      var value = normalizePropertyValue(pair[1]);

      if (obj[key] !== undefined) {
        if (!Array.isArray(obj[key])) obj[key] = [obj[key]];
        obj[key].push(value);
      } else {
        obj[key] = value;
      }
    }
    return obj;
  }

  function getProductIdFromPage() {
    var productForm = document.querySelector('form[data-product-id]');
    if (productForm) {
      return (
        productForm.getAttribute('data-product-id') ||
        productForm.dataset.productId ||
        null
      );
    }

    return window.__PRODUCT_ID__ || null;
  }

  function getProductIdFromForm(form, formData) {
    return (
      formData.get('product_id') ||
      form.getAttribute('data-product-id') ||
      form.dataset.productId ||
      window.__PRODUCT_ID__ ||
      null
    );
  }

  function buildPayloadFromForm(form) {
    var formData = new FormData(form);

    var variantId = formData.get('id');
    var productId = getProductIdFromForm(form, formData);
    var quantity = safeParseInt(formData.get('quantity') || 1, 1);
    var attributes = extractLineItemProperties(formData);
    var sellingPlanId = formData.get('selling_plan') || null;

    return {
      merchandiseId: toVariantGid(variantId),
      productId: toProductGid(productId),
      quantity: quantity,
      attributes: attributes,
      sellingPlanId: toSellingPlanGid(sellingPlanId)
    };
  }

  function tryParseRequestBody(body) {
    if (!body) return null;

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      var paramsObj = {};
      body.forEach(function (value, key) {
        if (paramsObj[key] !== undefined) {
          if (!Array.isArray(paramsObj[key])) paramsObj[key] = [paramsObj[key]];
          paramsObj[key].push(value);
        } else {
          paramsObj[key] = value;
        }
      });
      return paramsObj;
    }

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return formDataToPlainObject(body);
    }

    if (typeof body === 'string') {
      try {
        var parsedJson = JSON.parse(body);
        if (parsedJson && typeof parsedJson === 'object') return parsedJson;
      } catch (e) {}

      try {
        var params = new URLSearchParams(body);
        var obj = {};
        params.forEach(function (value, key) {
          if (obj[key] !== undefined) {
            if (!Array.isArray(obj[key])) obj[key] = [obj[key]];
            obj[key].push(value);
          } else {
            obj[key] = value;
          }
        });
        return obj;
      } catch (e2) {}
    }

    return null;
  }

  function fingerprintPayload(payload) {
    return JSON.stringify({
      merchandiseId: payload && payload.merchandiseId,
      productId: payload && payload.productId,
      quantity: payload && payload.quantity,
      attributes: payload && payload.attributes,
      sellingPlanId: payload && payload.sellingPlanId
    });
  }

  function shouldDedupe(payload) {
    var now = Date.now();
    var fp = fingerprintPayload(payload);

    if (
      lastEventFingerprint &&
      fp === lastEventFingerprint &&
      now - lastEventAt < DEDUPE_MS
    ) {
      return true;
    }

    lastEventFingerprint = fp;
    lastEventAt = now;
    return false;
  }

  function sendToVenn(payload, meta) {
    if (!payload || !payload.merchandiseId) {
      log('Skipping payload because merchandiseId is missing', payload, meta);
      return;
    }

    if (shouldDedupe(payload)) {
      log('Deduped payload', payload, meta);
      return;
    }

    persistPayload(payload, meta);

    log('Sending payload', payload, meta);

    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.addCartLine &&
      typeof window.webkit.messageHandlers.addCartLine.postMessage === 'function'
    ) {
      try {
        window.webkit.messageHandlers.addCartLine.postMessage(payload);
        log('Sent via webkit.messageHandlers.addCartLine.postMessage', payload);
        return;
      } catch (err) {
        console.error('[Venn bridge] webkit.messageHandlers.addCartLine.postMessage failed', err, payload);
      }
    }

    if (
      window.JavaInterface &&
      typeof window.JavaInterface.addCartLine === 'function'
    ) {
      try {
        window.JavaInterface.addCartLine(JSON.stringify(payload));
        log('Sent via JavaInterface.addCartLine', payload);
        return;
      } catch (err) {
        console.error('[Venn bridge] JavaInterface.addCartLine failed', err, payload);
        return;
      }
    }

    log('No supported Venn bridge found - test mode only', payload, meta);
  }

  function extendMeta(base, extra) {
    var out = {};
    var key;

    base = base || {};
    extra = extra || {};

    for (key in base) {
      if (Object.prototype.hasOwnProperty.call(base, key)) {
        out[key] = base[key];
      }
    }

    for (key in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, key)) {
        out[key] = extra[key];
      }
    }

    return out;
  }

  function sendPayloadsToVenn(payloads, meta) {
    if (!Array.isArray(payloads) || !payloads.length) return;

    payloads.forEach(function (payload, index) {
      var payloadToSend = {
        merchandiseId: payload.merchandiseId,
        productId: payload.productId,
        quantity: payload.quantity,
        sellingPlanId: payload.sellingPlanId,
        attributes: {}
      };

      if (payload && payload.attributes && typeof payload.attributes === 'object') {
        Object.keys(payload.attributes).forEach(function (key) {
          payloadToSend.attributes[key] = payload.attributes[key];
        });
      }

      if (
        payloadToSend.attributes &&
        payloadToSend.attributes._pc_pricing_ref &&
        !payloadToSend.attributes.__venn_bundle_id
      ) {
        payloadToSend.attributes.__venn_bundle_id =
          payloadToSend.attributes._pc_pricing_ref;
      }

      sendToVenn(payloadToSend, extendMeta(meta, { resolvedIndex: index }));
    });
  }

  function extractLineItemPropertiesFromObject(obj) {
    var attributes = {};

    Object.keys(obj).forEach(function (key) {
      var match = key.match(/^properties\[(.*)\]$/);
      if (!match) return;

      var name = match[1];
      var value = obj[key];

      if (value === '' || value == null) return;

      if (attributes[name] !== undefined) {
        if (!Array.isArray(attributes[name])) {
          attributes[name] = [attributes[name]];
        }
        attributes[name].push(value);
      } else {
        attributes[name] = value;
      }
    });

    return attributes;
  }

  function buildSinglePayload(item, fallbackProductId) {
    var variantId = item.id || item.variant_id || null;
    var productId = item.product_id || fallbackProductId || null;
    var quantity = safeParseInt(item.quantity || 1, 1);
    var sellingPlanId = item.selling_plan || item.selling_plan_id || null;
    var attributes = item.properties || extractLineItemPropertiesFromObject(item) || {};

    return {
      merchandiseId: toVariantGid(variantId),
      productId: toProductGid(productId),
      quantity: quantity,
      attributes: attributes,
      sellingPlanId: toSellingPlanGid(sellingPlanId)
    };
  }

  function buildPayloadsFromFormData(formDataObj) {
    var payloads = [];
    var fallbackProductId = getProductIdFromPage() || null;

    if (Array.isArray(formDataObj.items)) {
      formDataObj.items.forEach(function (item) {
        var payload = buildSinglePayload(item, fallbackProductId);
        if (payload && payload.merchandiseId) {
          payloads.push(payload);
        }
      });
      return payloads;
    }

    var indexedItems = {};
    Object.keys(formDataObj).forEach(function (key) {
      var match = key.match(/^items\[(\d+)\]\[(.+)\]$/);
      if (!match) return;

      var index = match[1];
      var field = match[2];

      if (!indexedItems[index]) indexedItems[index] = {};
      indexedItems[index][field] = formDataObj[key];
    });

    var indexedKeys = Object.keys(indexedItems);
    if (indexedKeys.length) {
      indexedKeys.forEach(function (index) {
        var payload = buildSinglePayload(indexedItems[index], fallbackProductId);
        if (payload && payload.merchandiseId) {
          payloads.push(payload);
        }
      });
      return payloads;
    }

    var singlePayload = buildSinglePayload(formDataObj, fallbackProductId);
    if (singlePayload && singlePayload.merchandiseId) {
      payloads.push(singlePayload);
    }

    return payloads;
  }

  function getPayloadProperty(payload, key) {
    return payload &&
      payload.attributes &&
      Object.prototype.hasOwnProperty.call(payload.attributes, key)
      ? payload.attributes[key]
      : null;
  }

  function isZeptoPayload(payload) {
    return !!(
      getPayloadProperty(payload, '_pc_pricing_ref') ||
      getPayloadProperty(payload, '_pc_pricing_qty_split')
    );
  }

  function shouldResolvePayloadsFromCart(payloads) {
    return Array.isArray(payloads) && payloads.some(isZeptoPayload);
  }

  function collectPricingRefsFromPayloads(payloads) {
    var refs = {};

    if (!Array.isArray(payloads)) return [];

    payloads.forEach(function (payload) {
      var ref = getPayloadProperty(payload, '_pc_pricing_ref');
      if (ref) refs[String(ref)] = true;
    });

    return Object.keys(refs);
  }

  function cartLineProperties(line) {
    return clonePlainObject((line && line.properties) || {});
  }

  function cartLineKey(line) {
    return line && line.key ? String(line.key) : null;
  }

  function getCartSnapshotMap(cart) {
    var map = {};
    var items = (cart && cart.items) || [];

    items.forEach(function (line) {
      var key = cartLineKey(line);
      if (!key) return;
      map[key] = {
        quantity: safeParseInt(line.quantity || 0, 0),
        variant_id: String(line.variant_id || ''),
        product_id: String(line.product_id || ''),
        properties: cartLineProperties(line)
      };
    });

    return map;
  }

  function lineMatchesPricingRefs(line, pricingRefs) {
    if (!pricingRefs || !pricingRefs.length) return false;

    var props = cartLineProperties(line);
    var ref = props._pc_pricing_ref;

    return !!(ref && pricingRefs.indexOf(String(ref)) !== -1);
  }

  function buildPayloadFromCartLine(line, quantityOverride) {
    if (!line || !line.variant_id) return null;

    var sellingPlanId = null;
    if (
      line.selling_plan_allocation &&
      line.selling_plan_allocation.selling_plan &&
      line.selling_plan_allocation.selling_plan.id
    ) {
      sellingPlanId = line.selling_plan_allocation.selling_plan.id;
    } else if (line.selling_plan) {
      sellingPlanId = line.selling_plan;
    }

    return {
      merchandiseId: toVariantGid(line.variant_id),
      productId: toProductGid(line.product_id || null),
      quantity: safeParseInt(
        quantityOverride != null ? quantityOverride : line.quantity || 1,
        1
      ),
      attributes: cartLineProperties(line),
      sellingPlanId: toSellingPlanGid(sellingPlanId)
    };
  }

  function buildResolvedPayloadsFromCart(beforeCart, afterCart, pricingRefs) {
    var beforeMap = getCartSnapshotMap(beforeCart);
    var resolved = [];
    var items = (afterCart && afterCart.items) || [];

    items.forEach(function (line) {
      if (!lineMatchesPricingRefs(line, pricingRefs)) return;

      var key = cartLineKey(line);
      var beforeLine = key ? beforeMap[key] : null;
      var afterQty = safeParseInt(line.quantity || 0, 0);
      var beforeQty = beforeLine ? safeParseInt(beforeLine.quantity || 0, 0) : 0;
      var delta = afterQty - beforeQty;

      if (delta <= 0) return;

      var payload = buildPayloadFromCartLine(line, delta);
      if (payload && payload.merchandiseId) {
        resolved.push(payload);
      }
    });

    return resolved;
  }

  function buildResolvedPayloadsFromCartDelta(beforeCart, afterCart) {
    var beforeMap = getCartSnapshotMap(beforeCart);
    var resolved = [];
    var items = (afterCart && afterCart.items) || [];

    items.forEach(function (line) {
      var key = cartLineKey(line);
      var beforeLine = key ? beforeMap[key] : null;
      var afterQty = safeParseInt(line.quantity || 0, 0);
      var beforeQty = beforeLine ? safeParseInt(beforeLine.quantity || 0, 0) : 0;
      var delta = afterQty - beforeQty;

      if (delta <= 0) return;

      var payload = buildPayloadFromCartLine(line, delta);
      if (payload && payload.merchandiseId) {
        resolved.push(payload);
      }
    });

    return resolved;
  }

  function getCartJson() {
    if (!originalFetchFn) {
      return Promise.reject(new Error('Fetch is not available for cart reconciliation'));
    }

    return originalFetchFn('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart request failed with status ' + response.status);
      }
      return response.json();
    });
  }

  function delay(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function storeLastCartSnapshot(cart) {
    setSessionJson(LAST_CART_SNAPSHOT_KEY, {
      timestamp: Date.now(),
      cart: cart
    });
  }

  function getLastCartSnapshot() {
    var stored = getSessionJson(LAST_CART_SNAPSHOT_KEY);
    return stored && stored.cart ? stored.cart : { items: [] };
  }

  function queuePendingFormReconcile(data) {
    setSessionJson(PENDING_FORM_RECONCILE_KEY, data);
    persistLog('Queued pending form reconcile', data);
  }

  function pageHasZeptoSignals() {
    return !!(
      document.querySelector('[class*="pplr"], [id*="pplr"], [data-pplr], [name^="properties[_pc_"]') ||
      document.querySelector('script[src*="pplr"]')
    );
  }

  function warmCartSnapshot() {
    return getCartJson()
      .then(function (cart) {
        storeLastCartSnapshot(cart);
        persistLog('Warmed cart snapshot', { cart: cart });
      })
      .catch(function (err) {
        persistLog('Warm cart snapshot error', {
          error: String(err && err.message ? err.message : err)
        });
      });
  }

  function processPendingFormReconcileOnLoad() {
    var pending = getSessionJson(PENDING_FORM_RECONCILE_KEY);
    if (!pending) return Promise.resolve();

    var ageMs = Date.now() - (pending.timestamp || 0);
    if (ageMs > 2 * 60 * 1000) {
      persistLog('Discarded stale pending form reconcile', pending);
      removeSessionKey(PENDING_FORM_RECONCILE_KEY);
      return Promise.resolve();
    }

    return getCartJson()
      .then(function (afterCart) {
        persistLog('Pending form reconcile after cart', {
          pending: pending,
          afterCart: afterCart
        });

        var beforeCart = pending.beforeCart || { items: [] };
        var resolvedPayloads = buildResolvedPayloadsFromCartDelta(beforeCart, afterCart);
        var sourcePayloads = pending.sourcePayloads || [];
        var mergedResolvedPayloads = mergeResolvedPayloadsWithSourcePayloads(resolvedPayloads, sourcePayloads);

        persistLog('Pending form reconcile resolved payloads', {
          pending: pending,
          resolvedPayloads: resolvedPayloads,
          mergedResolvedPayloads: mergedResolvedPayloads,
          sourcePayloads: sourcePayloads
        });

        if (!mergedResolvedPayloads.length) {
          log('No resolved payloads found for pending form reconcile', pending);
          removeSessionKey(PENDING_FORM_RECONCILE_KEY);
          storeLastCartSnapshot(afterCart);
          return;
        }

        sendPayloadsToVenn(
          mergedResolvedPayloads,
          extendMeta(pending.meta || {}, {
            source: 'form-submit-cart-reconcile',
            pendingFormReconcile: true
          })
        );

        removeSessionKey(PENDING_FORM_RECONCILE_KEY);
        storeLastCartSnapshot(afterCart);
      })
      .catch(function (err) {
        console.error('[Venn bridge] Failed processing pending form reconcile', err, pending);
        persistLog('Pending form reconcile error', {
          pending: pending,
          error: String(err && err.message ? err.message : err)
        });
      });
  }

  function reconcileZeptoPayloads(payloads, meta, options) {
    options = options || {};

    var pricingRefs = collectPricingRefsFromPayloads(payloads);
    if (!pricingRefs.length) {
      log('Skipping Zepto reconciliation because no _pc_pricing_ref values were found', payloads, meta);
      return Promise.resolve();
    }

    var beforeCart = options.beforeCart || null;
    var settleDelayMs = options.settleDelayMs != null ? options.settleDelayMs : 1000;

    persistLog('Zepto reconcile start', {
      meta: meta,
      pricingRefs: pricingRefs,
      beforeCart: beforeCart
    });

    var expectedCount = countExpectedPayloadsForPricingRefs(payloads, pricingRefs);
      persistLog('Zepto reconcile expected count', {
      pricingRefs: pricingRefs,
      expectedCount: expectedCount,
      sourcePayloads: payloads
    });

        return delay(settleDelayMs)
          .then(function () {
            return waitForCartLinesByPricingRefs(pricingRefs, expectedCount, {
              timeoutMs: 5000,
              intervalMs: 300
            });
          })
          .then(function (afterCart) {
        persistLog('Zepto reconcile after cart', {
          meta: meta,
          pricingRefs: pricingRefs,
          afterCart: afterCart
        });

        storeLastCartSnapshot(afterCart);

        var resolvedPayloads = buildResolvedPayloadsFromCart(beforeCart, afterCart, pricingRefs);
        persistLog('Zepto resolved cart lines count', {
          pricingRefs: pricingRefs,
          count: resolvedPayloads.length,
          resolvedPayloads: resolvedPayloads
        });
        var mergedResolvedPayloads = mergeResolvedPayloadsWithSourcePayloads(resolvedPayloads, payloads);

        persistLog('Zepto reconcile resolved payloads', {
          meta: meta,
          pricingRefs: pricingRefs,
          resolvedPayloads: resolvedPayloads,
          mergedResolvedPayloads: mergedResolvedPayloads,
          sourcePayloads: payloads
        });

        if (!mergedResolvedPayloads.length) {
          log('No resolved Zepto payloads found after cart reconciliation', pricingRefs, meta);
          return;
        }

        sendPayloadsToVenn(
          mergedResolvedPayloads,
          extendMeta(meta, {
            source: (meta && meta.source ? meta.source : 'unknown') + '-cart-reconcile',
            pricingRefs: pricingRefs
          })
        );
      })
      .catch(function (err) {
        console.error('[Venn bridge] Failed reconciling Zepto payloads from cart', err, payloads, meta);
        persistLog('Zepto reconcile error', {
          meta: meta,
          pricingRefs: pricingRefs,
          error: String(err && err.message ? err.message : err)
        });
      });
  }

  function handleResolvedOrImmediatePayloads(payloads, meta, options) {
    options = options || {};

    if (!payloads || !payloads.length) {
      log('No payloads to handle', meta);
      return Promise.resolve();
    }

    if (shouldResolvePayloadsFromCart(payloads)) {
      log('Zepto-linked payloads detected, queueing bundle reconcile instead of sending immediately', payloads, meta);
      persistLog('Zepto-linked payloads detected', {
        payloads: payloads,
        meta: meta
      });

      return queueZeptoBundleReconcile(payloads, meta, options);
    }

    sendPayloadsToVenn(payloads, meta);
    return Promise.resolve();
  }
    
    function normalizeString(value) {
      return value == null ? '' : String(value);
    }

    function mergeAttributes(primary, fallback) {
      var out = {};
      var key;

      primary = primary || {};
      fallback = fallback || {};

      for (key in fallback) {
        if (Object.prototype.hasOwnProperty.call(fallback, key)) {
          out[key] = fallback[key];
        }
      }

      for (key in primary) {
        if (Object.prototype.hasOwnProperty.call(primary, key)) {
          out[key] = primary[key];
        }
      }

      return out;
    }

    function mergePayloadWithSourcePayload(resolvedPayload, sourcePayload) {
      if (!resolvedPayload) return resolvedPayload;
      if (!sourcePayload) return resolvedPayload;

      return {
        merchandiseId: resolvedPayload.merchandiseId || sourcePayload.merchandiseId || null,
        productId: resolvedPayload.productId || sourcePayload.productId || null,
        quantity: resolvedPayload.quantity != null ? resolvedPayload.quantity : sourcePayload.quantity,
        sellingPlanId: resolvedPayload.sellingPlanId || sourcePayload.sellingPlanId || null,
        attributes: mergeAttributes(
          resolvedPayload.attributes || {},
          sourcePayload.attributes || {}
        )
      };
    }

    function findBestSourcePayloadForResolvedPayload(resolvedPayload, sourcePayloads) {
      if (!resolvedPayload || !Array.isArray(sourcePayloads) || !sourcePayloads.length) return null;

      var resolvedBundleId =
        getPayloadProperty(resolvedPayload, '_pc_pricing_ref') ||
        getPayloadProperty(resolvedPayload, '__venn_bundle_id') ||
        null;

      var resolvedMerchandiseId = normalizeString(resolvedPayload.merchandiseId);

      var exactMerchandiseMatch = sourcePayloads.find(function (sourcePayload) {
        return normalizeString(sourcePayload && sourcePayload.merchandiseId) === resolvedMerchandiseId;
      });
      if (exactMerchandiseMatch) return exactMerchandiseMatch;

      if (resolvedBundleId) {
        var bundleMatch = sourcePayloads.find(function (sourcePayload) {
          var sourceBundleId =
            getPayloadProperty(sourcePayload, '_pc_pricing_ref') ||
            getPayloadProperty(sourcePayload, '__venn_bundle_id') ||
            null;

          return normalizeString(sourceBundleId) === normalizeString(resolvedBundleId);
        });
        if (bundleMatch) return bundleMatch;
      }

      return null;
    }

    function mergeResolvedPayloadsWithSourcePayloads(resolvedPayloads, sourcePayloads) {
      if (!Array.isArray(resolvedPayloads) || !resolvedPayloads.length) return resolvedPayloads || [];

      return resolvedPayloads.map(function (resolvedPayload) {
        var sourcePayload = findBestSourcePayloadForResolvedPayload(resolvedPayload, sourcePayloads);
        return mergePayloadWithSourcePayload(resolvedPayload, sourcePayload);
      });
    }

  printPersistedDebug();
  processPendingFormReconcileOnLoad();
  warmCartSnapshot();

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var action = form.getAttribute('action') || '';
    if (!isCartAddUrl(action)) return;

    try {
      var payload = buildPayloadFromForm(form);
      var hasZeptoOnPage = pageHasZeptoSignals();

      persistLog('Form submit payload', {
        payload: payload,
        action: action,
        hasZeptoOnPage: hasZeptoOnPage
      });

      if (hasZeptoOnPage) {
        queuePendingFormReconcile({
          timestamp: Date.now(),
          beforeCart: getLastCartSnapshot(),
          sourcePayloads: [payload],
          meta: {
            source: 'form-submit',
            action: action,
            originalUrl: window.location.href,
            submittedMerchandiseId: payload.merchandiseId,
            submittedProductId: payload.productId
          }
        });

        log('Queued form-submit reconciliation instead of immediate send', payload);
        return;
      }

      sendToVenn(payload, { source: 'form-submit', action: action });
    } catch (err) {
      console.error('[Venn bridge] Failed building payload from form', err, form);
    }
  });

  if (window.fetch && originalFetchFn) {
    window.fetch = function () {
      var input = arguments[0];
      var init = arguments[1] || {};

      var url = typeof input === 'string' ? input : (input && input.url);
      var method = (init.method || (input && input.method) || 'GET').toUpperCase();

      if (method === 'POST' && isCartAddUrl(url)) {
        var parsedBody = null;
        var payloads = [];
        var beforeCartPromise = null;

        try {
          parsedBody = tryParseRequestBody(init.body);
          if (parsedBody) {
            payloads = buildPayloadsFromFormData(parsedBody);

            persistLog('Fetch cart add parsed body', {
              url: url,
              parsedBody: parsedBody,
              payloads: payloads
            });

            if (shouldResolvePayloadsFromCart(payloads)) {
              beforeCartPromise = getCartJson().catch(function (err) {
                console.warn('[Venn bridge] Failed getting before-cart snapshot for fetch reconciliation', err);
                persistLog('Fetch before-cart snapshot error', {
                  url: url,
                  error: String(err && err.message ? err.message : err)
                });
                return { items: [] };
              });
                
              beforeCartPromise.then(function (beforeCart) {
                queueZeptoBundleReconcile(payloads, {
                  source: 'fetch',
                  url: url
                }, {
                  beforeCart: beforeCart
                });
              });
            }
          } else {
            log('Could not parse fetch body for cart add', url, init.body);
          }
        } catch (err) {
          console.error('[Venn bridge] Failed parsing fetch cart add', err, url, init.body);
        }

        return originalFetchFn.apply(this, arguments).then(function (response) {
          if (!parsedBody || !payloads.length) {
            return response;
          }

          var meta = {
            source: 'fetch',
            url: url
          };

          if (shouldResolvePayloadsFromCart(payloads)) {
              return response;
            }

          return handleResolvedOrImmediatePayloads(payloads, meta).then(function () {
            return response;
          });
        });
      }

      return originalFetchFn.apply(this, arguments);
    };
  }

  (function () {
      var originalOpen = XMLHttpRequest.prototype.open;
      var originalSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url) {
        this.__vennMethod = method;
        this.__vennUrl = url;
        return originalOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function (body) {
        var parsedBody = null;
        var payloads = [];
        var beforeCartPromise = null;
        var self = this;

        try {
          if (
            this.__vennMethod &&
            this.__vennMethod.toUpperCase() === 'POST' &&
            isCartAddUrl(this.__vennUrl)
          ) {
            persistLog('XHR cart add raw body', {
              url: this.__vennUrl,
              method: this.__vennMethod,
              body: body
            });

            parsedBody = tryParseRequestBody(body);

            persistLog('XHR cart add parsed body', {
              url: this.__vennUrl,
              parsedBody: parsedBody
            });

            if (parsedBody) {
              payloads = buildPayloadsFromFormData(parsedBody);

              persistLog('XHR built payloads', {
                url: this.__vennUrl,
                payloads: payloads
              });

              if (shouldResolvePayloadsFromCart(payloads)) {
                beforeCartPromise = getCartJson().catch(function (err) {
                  console.warn('[Venn bridge] Failed getting before-cart snapshot for XHR reconciliation', err);
                  persistLog('XHR before-cart snapshot error', {
                    url: self.__vennUrl,
                    error: String(err && err.message ? err.message : err)
                  });
                  return { items: [] };
                });

                beforeCartPromise.then(function (beforeCart) {
                  queueZeptoBundleReconcile(payloads, {
                    source: 'xhr',
                    url: self.__vennUrl
                  }, {
                    beforeCart: beforeCart
                  });
                });
              }

              this.addEventListener('load', function () {
                if (self.status < 200 || self.status >= 300) {
                  log('Skipping post-XHR handling because request did not succeed', self.__vennUrl, self.status);
                  return;
                }

                var meta = {
                  source: 'xhr',
                  url: self.__vennUrl
                };

                if (!payloads.length) {
                  log('No payloads built from XHR body', parsedBody);
                  return;
                }

                if (shouldResolvePayloadsFromCart(payloads)) {
                  return;
                }

                handleResolvedOrImmediatePayloads(payloads, meta).catch(function (err) {
                  console.error('[Venn bridge] Failed handling XHR payloads', err, self.__vennUrl);
                });
              });
            } else {
              log('Could not parse XHR body for cart add', this.__vennUrl, body);
            }
          }
        } catch (err) {
          console.error('[Venn bridge] Failed parsing XHR cart add', err, this.__vennUrl, body);
        }

        return originalSend.apply(this, arguments);
      };
    })();
})();